import React from "react";

export default function Multiple({ elem }) {
  return (
    <div className="d-flex">
      {elem.values.map((elem, index) => {
        if (elem.type === "area") {
          return (
            <div className={"mb-2 w-50 " + (index == 0 ? "mr-1" : "ml-1")}>
              <label for="area">{elem.label}</label>
              <input
                type="text"
                className="form-control input-sm textInput especialGroup"
                name={elem.id}
                id={elem.id}
                key={elem.id}
                aria-describedby="areaHelp"
                placeholder={elem.placeholder}
              />
            </div>
          );
        } else if (elem.type === "date") {
          return (
            <div className="mb-2">
              <label for="comentario">{elem.label}</label>
              <input
                type="text"
                className="form-control input-sm textInput especialGroup formHover"
                name={elem.id}
                id={elem.id}
                aria-describedby="comentarioHelp"
                placeholder={elem.placeholder}
              />
            </div>
          );
        }
      })}
    </div>
  );
}
